import { changeLanguage, getInitialLanguage } from '../../src/app/common/utils/language.util';

// get language to route to and then route to that language, storing the information to local storage
const initialLanguage = getInitialLanguage();
changeLanguage(initialLanguage, '/static/', true);
